import { useState } from 'react';
import { Link } from 'react-router-dom';
import './navbar.css'

const Navbar = () => {
    const [menuState, setMenuState] = useState(false);
    const handleMenu = () => {
        setMenuState((menuState) => {
            return (!menuState)
        })
    }
    return (
        <>
            <nav className="navbar menu">
                <div className="nav_wrap">
                    <div className="nav-logo">Government High School, Gangapur</div>
                    <div className="center">
                        <ul className="nav-links">
                            <Link to={'/'}><li>Home</li></Link>
                            <Link to={'/about'}><li>About</li></Link>
                            <Link to={'/teachers'}><li>Teachers</li></Link>
                            <Link to={'/gallery'}><li>Gallery</li></Link>
                        </ul>
                    </div>

                    <ul className={menuState ? "mobile-nav is-active" : "mobile-nav"}>
                        <Link to={'/'}><li onClick={() => setMenuState(false)}>Home</li></Link>
                        <Link to={'/about'}><li onClick={() => setMenuState(false)}>About</li></Link>
                        <Link to={'/teachers'}><li onClick={() => setMenuState(false)}>Teachers</li></Link>
                        <Link to={'/gallery'}><li onClick={() => setMenuState(false)}>Gallery</li></Link>
                    </ul>
                    <div className="menu-btn" onClick={handleMenu}><i className={menuState ? "far fa-times-circle" : "fas fa-bars"} /></div>
                </div>
            </nav>
        </>
    );
}

export default Navbar; 